// extracted by mini-css-extract-plugin
export default {"bg":"App-module__bg"};